import { useEffect } from 'react';
import { business } from '../data/site';
const TITLE = 'Hot Tubs & Outdoor Furniture | Brooklyn, MI | Pegasus Spas';
const DESCRIPTION = 'Explore hot tubs, outdoor furniture, spa service, replacement covers and backyard living products at family-owned Pegasus Spas in Brooklyn, MI, since 1977.';
const CANONICAL = 'https://www.pegasus-spas.com/';
const STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: business.name,
  url: business.url,
  telephone: business.phone,
  address: {
    '@type': 'PostalAddress',
    streetAddress: business.street,
    addressLocality: business.city,
    addressRegion: business.state,
    postalCode: business.zip,
    addressCountry: 'US'
  },
  openingHoursSpecification: [{
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '10:00',
    closes: '18:00'
  }, {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Saturday'],
    opens: '09:00',
    closes: '15:00'
  }]
};
function upsertMeta(name: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function DocumentHead() {
  useEffect(() => {
    document.title = TITLE;
    upsertMeta('description', DESCRIPTION);
    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', CANONICAL);
    const scriptId = 'pegasus-local-business-jsonld';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(STRUCTURED_DATA);
  }, []);
  return null;
}